import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

const useWindowWidth = (): number => {
  const [width, setWidth] = useState(window.innerWidth);
  const handleResize = debounce((): void => setWidth(window.innerWidth), 444);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return width;
};

export default useWindowWidth;
